/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup, Card, CardHeader, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts,setCompanies, setDeliveryRequired, setPickupInstore, setCollectionId} from '../../actions/quote'
import { toast } from 'react-toastify';
import { API_URL } from 'network.js'
import { Tooltip } from 'reactstrap';

import {
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import location_img from "assets/img/location.png"

function Index(props) {
  const [contacts, setContacts] = useState([]);
  const [contact, setContact] = useState(null);
  const [editMode, setEditMode] = useState(false);  
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const main = useRef();

  const toggletooltip = () => setTooltipOpen(!tooltipOpen);
  

  useEffect(() => {
    // var userid = getuserid();
    // var role = getuserrole();
    if(props.company){
      if(props.company.contacts){
        var newContacts = props.company.contacts
        setContacts(newContacts)
        if(props.quote.collection_id){
          var newContactId = props.quote.collection_id;
          if(newContactId){
            var newContact = null;
            for(var i = 0; i < newContacts.length; i++){
              if(newContacts[i].id == newContactId){
                newContact = {...newContacts[i]};
                if(!newContact.company_name && props.company.company){
                  newContact.company_name = props.company.company;
                }
                setContact(newContact);
                break;
              }
            }
          }
        }
      }
    }
  },[props.company, props.quote.collection_id]);

  
  const toggleEditMode = ()=>{
    setEditMode(!editMode);
  }
  const {
    pickup_instore,
    delivery_required,
    collection_id
  } = props.quote;
  const isDeliveryChoiceMissing = !delivery_required && !pickup_instore;
  const isCollectionMissing = (delivery_required || pickup_instore) && !collection_id;

  return (
    <>
      <div className="bg-transparent border-0">
        <Row className="m-0">
          <Col xs="12" className="card-delivery">
            <FormGroup className={isDeliveryChoiceMissing ? "is-invalid" : ""}>
              <div className="d-flex justify-content-between align-items-center">
                <div className="custom-control custom-checkbox mt-0">
                  <input
                    className="custom-control-input"
                    id="customCheck-pickup"
                    type="checkbox"
                    checked={pickup_instore?true:false}
                    value={pickup_instore}
                    onChange={(e)=>props.setPickupInstore(!pickup_instore)}
                    disabled={props.mode=='view'}
                  />
                  <label className="custom-control-label" htmlFor="customCheck-pickup">
                    <b>Pick Up in store</b>
                  </label>
                </div>
                <a target="_blank" href={`https://maps.google.com/?q=unit 1/10 Klauer St Seaford Vic 3198`}>
                  <img width="25px" src={location_img}/>
                </a>
              </div>
              {isDeliveryChoiceMissing && (
                <div className="invalid-feedback d-block">
                  Please select pick up or delivery.
                </div>
              )}
            </FormGroup>
            <hr/>
            <FormGroup className={isDeliveryChoiceMissing ? "is-invalid" : ""}>
              <div className="custom-control custom-checkbox mt-0">
                <input
                  className="custom-control-input"
                  id="customCheck2"
                  type="checkbox"
                  name="delivery_required"
                  checked={delivery_required?true:false}
                  value={delivery_required}
                  onChange={(e)=>props.setDeliveryRequired(!delivery_required)}
                  disabled={props.mode=='view'}
                />
                <label className="custom-control-label" htmlFor="customCheck2" >
                  <b>Delivery</b>
                </label>
                <label className="help-icon" style={{marginLeft:"10px"}} href="#" id={`collection-delivery`}>i</label>
              </div>
              <Tooltip placement="bottom" isOpen={tooltipOpen} className="text-left" target="collection-delivery" toggle={toggletooltip}>
                Select delivery or pick up from our showroom.
              </Tooltip>
              {isDeliveryChoiceMissing && (
                <div className="invalid-feedback d-block">
                  Please select pick up or delivery.
                </div>
              )}
            </FormGroup>
            <hr/>
            <Row>
              <Col xs="8">
                <FormGroup className="mb-1">
                  <Input type="select" value={collection_id} name="id" onChange={(e)=>props.setCollectionId(e.target.value)} invalid={isCollectionMissing}>
                    <option value="">None</option>
                    {
                      (() => {
                        var element = [];
                        for(var key in contacts){
                          element.push(
                            <option key={key} value={contacts[key]['id']}>{(contacts[key]['firstname']?contacts[key]['firstname']:"")+" "+(contacts[key]['lastname']?contacts[key]['lastname']:"")+(contacts[key]['company_name']?(" - "+contacts[key]['company_name']):"")}</option>
                          )
                        }
                        return element
                      })()
                    }
                  </Input>                  
                  {isCollectionMissing && (
                    <div className="invalid-feedback d-block">
                      Please select a collection contact.
                    </div>
                  )}
                </FormGroup>
              </Col>
              <Col xs="4" className="d-flex align-items-center justify-content-end">
                  <div className="d-flex align-items-center cursor-pointer">
                    <a href={contact?`${API_URL}companies/addressespdf/${contact.id}`:`javascript:void(0)`} target="_blank"><i style={{fontSize:19, marginTop:1}} className="fa fa-file-pdf-o cursor-pointer mr-3" aria-hidden="true"></i></a>
                    {props.mode!='view'&&
                    <i onClick={(e)=>props.updateContact(contact)} style={{fontSize:19, marginTop:1}} className="fa fa-save cursor-pointer mr-1" aria-hidden="true"></i>
                    }
                  </div>
              </Col>
              {contact&&
              <>
                {!editMode?
                <Col xs="12">                
                  <div className="d-flex">
                    <div className="" style={{whiteSpace: 'break-spaces',padding:10, fontSize:13.5}}>
                      {contact&&contact.firstname?(contact.firstname+" "):''}{contact?(contact.lastname+" "):''}<br/>
                      {contact?(contact.company_name || props.company.company || ''):''}<br/>
                      {contact?contact.address:''}<br/>
                      {contact?contact.suburb:''} {contact?contact.state:''} {contact?contact.postcode:''}<br/>
                    </div>
                  </div>
                </Col>:
                <Col xs="12" className="pt-2">
                  <Row>
                    <Col md="6">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="First Name" type="text" name="firstname"  value={contact?contact.firstname:''} onChange={(e)=>setContact({...contact, firstname:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Last Name" type="text" name="lastname"  value={contact?contact.lastname:''} onChange={(e)=>setContact({...contact, lastname:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-2">
                        <Input className="input-field" disabled={!editMode} placeholder="Company Name" type="text" name="company_name" value={contact?contact.company_name:''} onChange={(e)=>setContact({...contact, company_name:e.target.value})}/>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Delivery Address" type="text" name="address"  value={contact?contact.address:''} onChange={(e)=>setContact({...contact, address:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Suburb" type="text" name="suburb"  value={contact?contact.suburb:''} onChange={(e)=>setContact({...contact, suburb:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="State" type="text" name="state"  value={contact?contact.state:''} onChange={(e)=>setContact({...contact, state:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup className="mb-2">
                        
                          <Input className="input-field" disabled = {!editMode} placeholder="Post Code" type="text" name="postcode"  value={contact?contact.postcode:''} onChange={(e)=>setContact({...contact, postcode:e.target.value})}/>
                        
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
                }
              </>
              }
            </Row>
            {props.mode!='view'&&
            <Row className="mt-2">
              <Col md="6">
                <div onClick={(e)=>toggleEditMode()} className="d-flex align-items-center cursor-pointer">
                  <i style={{fontSize:18, marginTop:1}} className="fa fa-pencil cursor-pointer mr-1" aria-hidden="true"></i>
                  <span style={{fontSize:14}}>Edit</span>
                </div>
              </Col>
              <Col md="6">
              </Col>
            </Row>
            }
          </Col>
        </Row>
      </div>
      

    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    setCompanies: companies=>dispatch(setCompanies(companies)),
    setDeliveryRequired: value=>dispatch(setDeliveryRequired(value)),
    setPickupInstore: value=>dispatch(setPickupInstore(value)),
    setCollectionId: value=>dispatch(setCollectionId(value)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
